import { ActionAfterViewObserver } from '@cian/action-after-viewed-component';
import { EntryPoint, ModalCloseButton, ModalContent, ModalHeader, ModalRoot, UIHeading4 } from '@cian/ui-kit';
import { IconActionClose12 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';

import * as styles from './ChatMessageMenu.css';
import { TChatMessageMenuItem } from '../../types/chatMessageMenuItem';

interface IChatMessageMenuProps {
  menuItems: TChatMessageMenuItem[];
  onShow(): void;
  onClose(): void;
  chatId: string;
  messageId: string;
}

export const ChatMessageMenu: React.FC<IChatMessageMenuProps> = ({ onShow, onClose, menuItems, chatId, messageId }) => {
  const items = React.useMemo(
    () =>
      menuItems.map(({ title, color, icon, handler }, index) => (
        <li key={`chat-message-menu-${index}`} className={styles['item']} style={{ color }}>
          <EntryPoint
            colorType="default"
            title={<UIHeading4 color="current_color">{title}</UIHeading4>}
            image={{ content: icon, background: 'transparent' }}
            onClick={() => {
              onClose();
              handler(chatId, messageId);
            }}
          />
        </li>
      )),
    [menuItems, onClose, chatId, messageId],
  );

  return (
    <ModalRoot open onOpenChange={onClose}>
      <ModalContent className={styles['modal']}>
        <ModalCloseButton
          size="XS"
          theme="fill_light"
          title="Закрыть"
          icon={<IconActionClose12 color="current_color" />}
        />
        <ModalHeader />
        <ActionAfterViewObserver callback={onShow} triggerOnce={false} wrapper={false}>
          <ul className={styles['container']} data-name="ChatMessageMenu_list">
            {items}
          </ul>
        </ActionAfterViewObserver>
      </ModalContent>
    </ModalRoot>
  );
};
